export default (date) => {
  if (date) {
    return new Date(Date.parse(date.replaceAll('-', '/'))).toLocaleString('es').slice(0, -3)
  } else {
    return date
  }
}
